import React, { useEffect, useState } from "react";
import { getTTSContext } from "src/apis/TTS/context.api";
import Controls from "src/components/form/controls/Controls";

const typeOption = [
  {
    id: "response",
    name: "response",
  },
  {
    id: "success",
    name: "success",
  },
  {
    id: "error",
    name: "error",
  },
];

const TTSIntentPanelOptional = ({ type, setType, contextId, setContextId }) => {
  const [contextNamespaces, setContextNamespaces] = useState([]);

  useEffect(() => {
    getTTSContext({ contextType: type }, (result) => {
      if (result) {
        handleSetContextNameSpace([...result.list]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const handleSetContextNameSpace = (listContextNamespace) => {
    const listContextNamespaceFormat = listContextNamespace.map(
      (contextNamespace) => ({
        id: contextNamespace?.id,
        name: contextNamespace?.contextNamespace,
      })
    );

    setContextNamespaces([...listContextNamespaceFormat]);
    setContextId(listContextNamespaceFormat[0]?.id);
  };

  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="type"
        label="Type"
        value={type}
        onChange={(e) => setType(e.target.value)}
        options={typeOption}
        style={{ width: "200px" }}
      />

      <Controls.Select
        name="contextId"
        label="contextNamespace"
        value={contextId}
        onChange={(e) => setContextId(e.target.value)}
        options={contextNamespaces}
        style={{ width: "200px", marginLeft: "10px" }}
      />
    </div>
  );
};

export default TTSIntentPanelOptional;
